import React, { Component } from "react";
import ReportGeneralTable from "./ReportGeneralTable";
import ReportStore from "../../stores/ReportStore";
import FontAwesome from "react-fontawesome";
import { Checkbox } from "react-icheck";
import { Popover, OverlayTrigger, Tabs, Tab } from "react-bootstrap";
import IframeModal from "../../component/element/IframeModal";
const viewModeList = ["all", "unpaid", "paid", "cancel"];
class ReportReceiptPage extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      data: [],
      showTable: true,
      activeKey: 1,
      isCheckAll: false,
      check: [],
      showSelectMenu: false,
    };
  }

  // renameDoc(newPoNo){
  //   this.refs.soDoc.renameDoc(newPoNo)
  // }

  showTable() {
    this.setState({ showTable: true });
    this.refs.qoTable.refreshTable();
    if (this.props.onTableShow !== undefined) {
      this.props.onTableShow();
    }
  }

  onRowSelect(item) {
    this.setState({ showTable: false });

    if (this.props.onDocShow !== undefined) {
      this.props.onDocShow(item.doc_no);
    }
  }

  // onDocNew(){
  //   this.setState({showTable:false})
  //   let that = this
  //   this.refs.soDoc.loadNewDoc(function(item){
  //     if(that.props.onDocShow!==undefined){
  //       that.props.onDocShow(item.sale_order_no)
  //     }
  //   })
  // }

  // onDocClose(){
  //   this.showTable()
  // }

  // loadData2(year,month,day,searchBy,query,activePage,itemPerPage,callback){
  //   ReportStore.loadReceiptList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,callback)
  // }

  loadData(
    year,
    month,
    day,
    searchBy,
    query,
    activePage,
    itemPerPage,
    callback
  ) {
    let { activeKey } = this.state;

    ReportStore.loadReceiptList(
      viewModeList[activeKey - 1],
      year,
      month,
      day,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      (result) => {
        this.processData(result);
        callback(result);
      }
    );
  }

  loadDataRange(
    start,
    end,
    searchBy,
    query,
    activePage,
    itemPerPage,
    callback
  ) {
    let { activeKey } = this.state;

    ReportStore.loadReceiptListRange(
      viewModeList[activeKey - 1],
      start,
      end,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      (result) => {
        this.processData(result);
        callback(result);
      }
    );
  }

  processData(result) {
    let { activeKey } = this.state;
    if (activeKey === 1) {
      result.data = result.data.map((item, index) => {
        item = Object.assign({ check: false }, item);
        return item;
      });
      // if (check.length===0)
      //   this.setState({check:new Array(result.data.length).fill(false)})
      // else
      //   this.setState({check:check})
      this.setState({
        isCheckAll: false,
        showSelectMenu: false,
        check: new Array(result.data.length).fill(false),
      });
    }
    this.setState({ data: result.data });
  }

  renderStatus(status, row) {
    let result = <span></span>;

    if (row.work_status === "0") {
      result = (
        <span className="label label-default" data-value="0">
          <FontAwesome name="clock-o" /> เริ่มต้น
        </span>
      );
    } else if (row.work_status === "1") {
      result = (
        <span className="label label-warning" data-value="1">
          <FontAwesome name="wrench" /> อยู่ระหว่างซ่อม
        </span>
      );
    } else if (row.work_status === "2") {
      result = (
        <span className="label label-primary" data-value="2">
          <FontAwesome name="hourglass-start" /> รอส่งมอบรถ
        </span>
      );
    } else if (row.work_status === "3") {
      result = (
        <span className="label label-success" data-value="3">
          <FontAwesome name="thumbs-o-up" /> ปิดจบงาน
        </span>
      );
    } else if (row.work_status === "5") {
      result = (
        <span className="label label-purple" data-value="5">
          <FontAwesome name="bitcoin" /> ตั้งเบิก
        </span>
      );
    } else {
      result = <span></span>;
    }

    if (row.doc_status !== undefined && row.doc_status * 1 === 2) {
      result = (
        <div>
          {result}
          <span className="label label-success">
            <FontAwesome name="money" /> ชำระเงินแล้ว
          </span>
        </div>
      );
    }
    if (row.doc_cancel !== undefined && row.doc_cancel * 1 === 1) {
      result = (
        <div>
          {result}
          <span className="label label-danger">
            <FontAwesome name="trash" /> ยกเลิก
          </span>
        </div>
      );
    }

    if (row.doc_cancel_remark !== undefined && row.doc_cancel_remark !== "") {
      result = (
        <div>
          {result}
          <span className="label label-danger">
            <FontAwesome name="trash" /> {row.doc_cancel_remark}
          </span>
        </div>
      );
    }
    return result;
  }

  // renderStatus(status,row){
  //   return row.status_html
  // }

  // renderStockStatus(status){
  //   status = status*1
  //   if(status>0){
  //     return (<span className='label label-default'>ตัดสต๊อกแล้ว</span>)
  //   }else{
  //     return (<span></span>)
  //   }

  // }

  onIconClick(workNo, e) {
    if (process.env.NODE_ENV === "development") {
      alert("show_work_doc:" + workNo);
    } else {
      window.show_work_doc(workNo);
    }
  }

  onTabsSelect(e) {
    this.setState({ activeKey: e });
  }

  onPrintClick() {
    let { check, data } = this.state;
    let doc_nos = [];
    data.forEach(function (item, index) {
      if (check[index]) {
        doc_nos.push(item.doc_no);
      }
    });
    let doc_no = doc_nos.join();
    let url = "";
    if (process.env.NODE_ENV === "development") {
      url = "./?startPage=PrintShippingLabel&idlist=" + doc_no + "&doc=receipt";
    } else {
      url =
        "./pdf/v2/?startPage=PrintShippingLabel&idlist=" +
        doc_no +
        "&doc=receipt";
    }
    this.refs.iframe.loadUrl(url);
  }

  checkAll(check) {
    let { data } = this.state;
    let isCheckAll = true;
    check.forEach((item, index) => {
      if (!item && data[index].work_status !== "3") isCheckAll = false;
    });
    return isCheckAll;
  }

  onRenderColumn(data, col, row, rowIndex) {
    let { check, activeKey } = this.state;
    if (col === 0 && activeKey === 1) {
      return (
        <Checkbox
          onChange={this.onCheckChange.bind(this, rowIndex)}
          checked={check[rowIndex] !== false ? true : false}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
          disabled={row.work_status === "3" ? true : false}
        />
      );
    } else if (
      (col === 10 && activeKey === 1) ||
      (col === 9 && activeKey > 1)
    ) {
      return this.renderStatus(data, row);
    } else if ((col === 3 && activeKey === 1) || (col == 2 && activeKey > 1)) {
      if (data !== "") {
        let title = "ใบงานซ่อม " + data;
        let popoverHoverFocus = (
          <Popover id="popover-trigger-hover-focus" title={title}>
            <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
          </Popover>
        );

        return (
          <span>
            {data}{" "}
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement="right"
              overlay={popoverHoverFocus}
            >
              <FontAwesome
                onClick={this.onIconClick.bind(this, data)}
                className="text-blue"
                name="file-text-o"
              />
            </OverlayTrigger>
          </span>
        );
      }
    } else {
      return <span>{data}</span>;
    }
  }

  onCheckChange(rowIndex) {
    let { showSelectMenu, check, isCheckAll } = this.state;
    check[rowIndex] = !check[rowIndex];
    showSelectMenu = false;
    let key = check.findIndex((x) => x !== false);
    if (key !== -1) showSelectMenu = true;

    isCheckAll = this.checkAll(check);
    this.setState({
      check: check,
      showSelectMenu: showSelectMenu,
      isCheckAll: isCheckAll,
    });
  }

  onCheckAll() {
    let { data, isCheckAll, check } = this.state;
    if (data.length === 0) return false;

    if (!isCheckAll) {
      let newCheck = check.map((item, index) => {
        if (data[index].work_status === "3") return false;
        else return data[index];
      });

      this.setState({
        isCheckAll: true,
        check: newCheck,
        showSelectMenu: true,
      });
    } else {
      let newCheck = check.map((item, index) => {
        item = false;
        return item;
      });
      this.setState({
        isCheckAll: false,
        check: newCheck,
        showSelectMenu: false,
      });
    }
  }

  onRenderCheckAll(key, index) {
    return (
      <th
        key={key + "-" + index}
        className={"text-center"}
        style={{ width: "50px", maxWidth: "50px" }}
      >
        <Checkbox
          onChange={this.onCheckAll.bind(this)}
          checked={this.state.isCheckAll}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
        ></Checkbox>
      </th>
    );
  }

  render() {
    let { showTable, activeKey, showSelectMenu } = this.state;
    const headerTitles = [
      { title: "วันที่ออก", width: "100px" },
      { title: "ใบเสร็จรับเงิน", width: "120px" },
      { title: "ใบงานเลขที่", width: "220px" },
      { title: "ทะเบียนรถ", width: "150px" },
      { title: "ยี่ห้อ", width: "150px" },
      { title: "รุ่น", width: "150px" },
      { title: "กม.", width: "80px" },
      { title: "ชื่อลูกค้า", width: "200px" },
      { title: "มูลค่า(บาท)", width: "100px" },
      { title: "สถานะ", width: "100px" },
    ];
    const headerTitlesAll = [
      { title: "", width: "50px", checkAll: true },
      { title: "วันที่ออก", width: "100px" },
      { title: "ใบเสร็จรับเงิน", width: "120px" },
      { title: "ใบงานเลขที่", width: "220px" },
      { title: "ทะเบียนรถ", width: "150px" },
      { title: "ยี่ห้อ", width: "150px" },
      { title: "รุ่น", width: "150px" },
      { title: "กม.", width: "80px" },
      { title: "ชื่อลูกค้า", width: "200px" },
      { title: "มูลค่า(บาท)", width: "100px" },
      { title: "สถานะ", width: "100px" },
      { title: "หมายเหตุ", width: "100px" },
    ];
    const searchOptions = [
      {
        label: "เลขที่ใบเสร็จ",
        value: "receipt_no",
      },
      {
        label: "ใบงานเลขที่",
        value: "work_no",
      },
      {
        label: "ทะเบียนรถ",
        value: "car_registration_no",
      },
    ];
    const tabsList = [
      {
        key: "all",
        title: (
          <div>
            <FontAwesome name="files-o" /> ทั้งหมด
          </div>
        ),
        loadOnShow: true,
      },
      {
        key: "unpaid",
        title: (
          <div>
            <FontAwesome name="money" /> รอเก็บเงิน
          </div>
        ),
        loadOnShow: true,
      },
      {
        key: "paid",
        title: (
          <div>
            <FontAwesome name="thumbs-o-up" /> ได้รับเงินเรียบร้อย
          </div>
        ),
        loadOnShow: true,
      },
      {
        key: "cancel",
        title: (
          <div>
            <FontAwesome name="trash" /> ยกเลิก
          </div>
        ),
        loadOnShow: true,
      },
    ];
    return (
      <div>
        <Tabs
          activeKey={activeKey}
          id="tabs-report-invoice-page"
          onSelect={this.onTabsSelect.bind(this)}
        >
          {tabsList.map((item, index) => (
            <Tab key={index} eventKey={index + 1} title={item.title}>
              <div style={{ display: showTable ? "block" : "none" }}>
                <ReportGeneralTable
                  ref="rcTable"
                  title="ใบเสร็จรับเงิน"
                  newTitle="เพิ่มรายการ"
                  showNewButton={false}
                  showSelectMenu={showSelectMenu && activeKey === 1}
                  show={activeKey === index + 1}
                  loadFirst={activeKey === index + 1}
                  loadOnShow={item.loadOnShow}
                  headerTitles={
                    index + 1 === 1 ? headerTitlesAll : headerTitles
                  }
                  excludeColumn={[
                    "status_html",
                    "doc_no",
                    "doc_status",
                    "doc_cancel",
                    "doc_cancel_remark",
                  ]}
                  // bodyColumn={['doc_date','bill_no','work_no','car_registration_no','brand','model','mileage','customer_name','amount','work_status']}
                  excludeClickColumn={["work_no"]}
                  searchOptions={searchOptions}
                  searchBy={"receipt_no"}
                  loadData={this.loadData.bind(this)}
                  loadDataRange={this.loadDataRange.bind(this)}
                  onRenderColumn={this.onRenderColumn.bind(this)}
                  onRenderCheckAll={this.onRenderCheckAll.bind(
                    this,
                    item.key,
                    index
                  )}
                  onRowSelect={this.onRowSelect.bind(this)}
                  // onDocNew={this.onDocNew.bind(this)}
                  showPrintButton={true}
                  docType={"receipt"}
                  isMobile={this.props.isMobile}
                  viewMode={viewModeList[activeKey - 1]}
                  mobileFieldMap={{
                    title: "customer_name",
                    amount: "amount",
                    sub_title: "bill_no",
                    date: "doc_date",
                    status: "work_status",
                    sub_status: "",
                  }}
                  renderWorkStatus={this.renderStatus.bind(this)}
                  printTitle="พิมพ์ใบจ่าหน้าซอง"
                  onPrintClick={this.onPrintClick.bind(this)}
                  btnTitlePrint="พิมพ์ตาราง"
                />
              </div>
            </Tab>
          ))}
        </Tabs>
        <div style={{ display: !showTable ? "block" : "none" }}></div>
        <IframeModal ref="iframe" title={"พิมพ์เอกสาร"} />
      </div>
    );
  }
}

export default ReportReceiptPage;



// WEBPACK FOOTER //
// ./src/view/report/ReportReceiptPage.js